import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
const Portal = ({ children, elementId }) => {
  const [element, setElement] = useState(null);
  useEffect(() => {
    setTimeout(() => {
      const element2 = document.getElementById(elementId);
      setElement(element2);
    }, 500);
    return () => {
      setElement(null);
    };
  }, [elementId]);
  if (!element) {
    return null;
  }
  return createPortal(children, element);
};
export {
  Portal as default
};
//# sourceMappingURL=Portal.js.map
